var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('top-nav',{attrs:{"showLogo":true}}),_c('h1',[_vm._v("About Page")]),_c('p',[_vm._v("This is the about page content.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }